import Stickyfill from 'stickyfilljs';
import zenScroll from 'zenscroll';

const Scrolling = {
	scroller: null,
	Init() {
		Scrolling.ZenScroll();
		Scrolling.StickyFill();
		Scrolling.ScrollClass();
		Scrolling.ScrollFade();
	},
	ZenScroll() {
		const defaultOffset = (document.querySelector('.navbar--page') || document.querySelector('.navbar--primary'))
			.offsetHeight;
		const defaultDuration = 250;

		// Consider using css (scroll-margin-top: 5rem) instead of this
		// MAKE SURE TO TEST FIRST as it can be a little wonky
		// https://css-tricks.com/fixed-headers-and-jump-links-the-solution-is-scroll-margin-top/
		const edgeOffset = defaultOffset * 1.33333;
		zenScroll.setup(defaultDuration, edgeOffset);
		this.scroller = zenScroll;
	},
	StickyFill() {
		const elements = document.querySelectorAll('.sticky-element');
		const bootstrapElements = document.querySelectorAll('.sticky-top');
		Stickyfill.add(elements);
		Stickyfill.add(bootstrapElements);
	},
	ScrollClass() {
		const targets = document.querySelectorAll('.js--scroll-element');

		targets.forEach(target => {
			const trigger = document.querySelector(target.getAttribute('data-scroll-trigger')) || target;
			const threshold = target.getAttribute('data-scroll-threshold');
			const margin = target.getAttribute('data-scroll-margin');
			const once = target.hasAttribute('data-scroll-once');
			const root = document.querySelector(target.getAttribute('data-scroll-root'));
			const toggledClass = target.getAttribute('data-scroll-toggled-class') || 'js--is-inactive';

			const observerOptions = {
				root: root || null,
				rootMargin: margin || '0px',
				threshold: JSON.parse(threshold) || 0.25
			};

			const intersectCallback = entries => {
				entries.forEach(entry => {
					const isActive = entry.isIntersecting && entry.intersectionRatio >= threshold;

					if (isActive) {
						target.classList.remove(toggledClass);

						if (once) {
							/* eslint-disable-next-line no-use-before-define */
							observer.disconnect();
						}
					} else {
						target.classList.add(toggledClass);
					}
				});
			};

			const observer = new IntersectionObserver(intersectCallback, observerOptions);
			observer.observe(trigger);
		});
	},
	ScrollFade() {
		const targets = document.querySelectorAll('.js--scrollfade-element');

		targets.forEach(target => {
			const trigger = document.querySelector(target.getAttribute('data-scroll-trigger')) || target;
			const threshold = target.getAttribute('data-scroll-threshold');
			const margin = target.getAttribute('data-scroll-margin');
			const root = document.querySelector(target.getAttribute('data-scroll-root'));

			const observerOptions = {
				root: root || null,
				rootMargin: margin || '0px',
				threshold: JSON.parse(threshold)
			};

			const intersectCallback = entries => {
				entries.forEach(entry => {
					target.style.opacity = entry.intersectionRatio >= 0.7 ? 1 : entry.intersectionRatio ** 4; // eslint-disable-line
				});
			};

			const observer = new IntersectionObserver(intersectCallback, observerOptions);
			observer.observe(trigger);
		});
	}
};

export default Scrolling;
